import { render, staticRenderFns } from "./ModalObservacaoSerigy.vue?vue&type=template&id=d2bf4726"
import script from "./ModalObservacaoSerigy.vue?vue&type=script&lang=ts"
export * from "./ModalObservacaoSerigy.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports